module.exports = __webpack_public_path__ + "img/hd-banner.94a96409.png";